import { AccountType } from "../shared/types/accounts";

type QueueAccount = Pick<
  AccountType,
  "_id" | "login" | "loginAlias" | "queueEnabled"
>;

export function getQueueDisabledAccountsForPosts(
  posts: Array<{
    accountId?: string;
    accountIds?: string[];
    accounts?: QueueAccount[];
  }>,
  accountsById: Record<string, QueueAccount | undefined>
): QueueAccount[] {
  const queueDisabledAccounts = new Map<string, QueueAccount>();

  for (const post of posts) {
    const accountIds = post.accountIds?.length
      ? post.accountIds
      : post.accountId
        ? [post.accountId]
        : [];

    for (const accountId of accountIds) {
      const account =
        post.accounts?.find((candidate) => candidate._id === accountId) ||
        accountsById[accountId];

      if (account && !account.queueEnabled) {
        queueDisabledAccounts.set(accountId, account);
      }
    }
  }

  return [...queueDisabledAccounts.values()];
}

export function getQueueDisabledAccountsMessage(
  accounts: Pick<AccountType, "login" | "loginAlias">[]
): string {
  const accountNames = accounts.map(
    (account) => account.loginAlias || account.login || "Selected account"
  );

  if (accountNames.length === 1) {
    return `${accountNames[0]} has no Queue setup. Set up Queue in Queue settings or schedule this post for a specific time instead.`;
  }

  return `${accountNames.join(
    ", "
  )} have no Queue setup. Set up Queue in Queue settings or schedule these posts for specific times instead.`;
}
